// components/UI/PageTransitionWrapper.jsx
import { motion } from "framer-motion";

const pageVariants = {
  initial: {
    y: "-100%",
    opacity: 0,
  },
  in: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.9,
      ease: [0.77, 0, 0.175, 1],
    },
  },
  out: {
    y: "100%",
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0.77, 0, 0.175, 1],
    },
  },
};

const PageTransitionWrapper = ({ children }) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      className="min-h-screen w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageTransitionWrapper;
